export const phone = {
  mounted(el: HTMLElement) {
    const input: HTMLInputElement | null = el.querySelector('input')

    if (!input) return

    /**
     * Функция форматирования номера телефона
     * @param value
     */
    const formatPhone = (value: string) => {
      value = value.trim().replace(/[^0-9+]/g, '')

      if (value.length < 3) {
        value = '+7'
      }

      if (value.length > 12) {
        value = '+7' + value.slice(-10)
      }

      return value
    }

    input.addEventListener('input', () => {
      input.value = formatPhone(input.value)
    })

    input.addEventListener('paste', () => {
      input.value = formatPhone(input.value)

      input.dispatchEvent(new Event('input'))
    })

    input.addEventListener('focus', () => {
      if (input.value.trim().length < 3) {
        input.value = '+7'
      }
    })

    input.addEventListener('blur', () => {
      const value = formatPhone(input.value)

      if (value === '+7') {
        input.value = ''
      } else {
        input.value = value
      }

      input.dispatchEvent(new Event('input'))
    })
  },
}
